import { ClientSessionContext } from '../Services.Primary/SessionContext/ClientSessionContext';
import FlightingInteractionService from './FlightingInteractionService';

let clientSessionContext: ClientSessionContext | undefined;
let flightingInteraction: FlightingInteractionService | undefined;

export class FlightingService {
  public static isFlightEnabled = async (flight: string) => {
    this.setupRequestedService();

    let flightStatus = false;
    const availableFlights = (await clientSessionContext?.getContext())?.applicableFlights ?? [];
    if (availableFlights && availableFlights.indexOf(flight) !== -1) {
      flightStatus = true;
    }

    const isApplicable = flightingInteraction?.isFlightApplicable(flight, flightStatus);
    return isApplicable;
  };

  private static setupRequestedService = () => {
    if (!clientSessionContext || !flightingInteraction) {
      clientSessionContext = ClientSessionContext.getInstance();
      flightingInteraction = FlightingInteractionService.getInstance();
    }
  };
}
